import { render, staticRenderFns } from "./SectionMenuUser.vue?vue&type=template&id=1d846d2c&scoped=true&"
import script from "./SectionMenuUser.vue?vue&type=script&lang=js&"
export * from "./SectionMenuUser.vue?vue&type=script&lang=js&"
import style0 from "./SectionMenuUser.vue?vue&type=style&index=0&id=1d846d2c&prod&lang=sass&scoped=true&"
import style1 from "./SectionMenuUser.vue?vue&type=style&index=1&id=1d846d2c&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d846d2c",
  null
  
)

export default component.exports